import { Injectable } from '@angular/core';
import { RestApi } from '@core/api/rest.api';
import { BatchJobTypeParameter } from './batch-job-type-parameter.model';

@Injectable({
  providedIn: 'root',
})
export class BatchJobTypeParameterApi extends RestApi<BatchJobTypeParameter> {
  override endpoint = '/api/admin/batchjobtypeparameters';
}
